import { render, staticRenderFns } from "./drawer.vue?vue&type=template&id=46996785&"
import script from "./drawer.vue?vue&type=script&lang=ts&"
export * from "./drawer.vue?vue&type=script&lang=ts&"
import style0 from "./drawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports